import React, { useState } from 'react'
import withClinic from '../hooks/with_clinic';
import { ApolloResult, Clinic, Order, Practitioner, Product, ProductStockItem, Service, ServiceStockItem, } from '../store';
import { Row, Col, Typography, Empty } from 'antd';
import Search from 'antd/lib/input/Search';
import DateRange from '../components/date_range';
import { Form } from 'antd';
import { Table } from 'antd';
import { addDays, format, subDays } from 'date-fns';
import ButtonGroup from 'antd/lib/button/button-group';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../components/loading_indicator';
import Error from '../components/apollo_error';
import MultiSelect from '../components/multi_select';
import { formatMoney } from '../helpers/utils';
import { Avatar } from 'antd';
import { getPSIVar, get_psi } from '../graphql/product_stock_item';
import { getServiePsiVar, get_service_psi } from '../graphql/service';
interface P {
    currentClinic?: Clinic
}

const ServiceStockItemPage = (props: P) => {
    const clinicId = props.currentClinic?.id || "";
    // const clinicId = "clhobuntc0002s6019ajmqkcj";
    const [searchText, setSearchText] = useState<string | null>(null);
    const [filter, setFilter] = useState<string[]>([]);
    const [ranges, setRanges] = useState({ startDate: subDays(new Date(), 30), endDate: addDays(new Date(), 15) })
    const [form] = Form.useForm();
    const variables = getServiePsiVar({ clinicId, startDate: ranges.startDate, endDate: ranges.endDate, searchText, take: 150, status: filter });
    const { loading, data, error } = useQuery<ApolloResult<"serviceProductStockItems", ServiceStockItem[]>>(get_service_psi, { variables })
    if (loading) return <LoadingSpinner />
    if (error) return <Error error={error} />
    if (!data) return <Empty />
    const onDateChange = (startDate: Date, endDate: Date) => {
        setRanges({ startDate, endDate });
    }
    const columns: any[] = [
        {
            title: 'Name',
            dataIndex: "name",
            key: 'name',
            editable: false,
            sorter: (a: ServiceStockItem, b: ServiceStockItem) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Product',
            dataIndex: "product",
            key: "product",
            editable: false,
            sorter: (a: ServiceStockItem, b: ServiceStockItem) => a.product_stock_item.name.toLowerCase().localeCompare(b.product_stock_item.name.toLowerCase()),
            render: (v: ServiceStockItem, r: ServiceStockItem) => {
                return r.name
            },
        },
        {
            title: 'Stock',
            dataIndex: "stock",
            key: 'stock',
            sorter: (a: ServiceStockItem, b: ServiceStockItem) => Number(a.stock) - Number(b.stock),
            editable: false,
        },
        {
            title: 'Amount Per Product',
            dataIndex: "amount_per_product",
            key: 'amount_per_product',
            sorter: (a: ServiceStockItem, b: ServiceStockItem) => Number(a.amount_per_product) - Number(b.amount_per_product),
            editable: true,
        },
        {
            title: 'CreatedAt',
            dataIndex: "created_at",
            key: 'created_at',
            editable: false,
            sorter: (a: ServiceStockItem, b: ServiceStockItem) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
            render: (v: ServiceStockItem, r: ServiceStockItem) => {
                return format(new Date(r.created_at), 'dd MMM,yyyy');
            },
        },
    ];
    const control = (
        <Row style={{ marginTop: -18 }}>
            <Col flex={4}>
                <Row >
                    <Col span={8}>
                        <Typography level={2}>Product Stock Items</Typography>

                    </Col>
                    <Col span={8} offset={8}>
                        <Search
                            defaultValue={searchText || undefined}
                            placeholder="search ...."
                            allowClear
                            size="middle"
                            onSearch={(val: any) => setSearchText(val)}
                        />

                    </Col>
                </Row>
            </Col>
            <Col flex={0}>
                <DateRange startDate={ranges.startDate} endDate={ranges.endDate} onSelect={onDateChange} />
            </Col>
        </Row>
    );
    const context = (
        <Row style={{ marginTop: 8 }}>
            <Col span={24}>
                <Form form={form} component={false}>
                    <Table
                        showHeader={data.serviceProductStockItems.length > 0}
                        //components={{ body: { cell: EditableCell, } }}
                        // expandable={{ expandedRowRender, onExpandedRowsChange }}
                        dataSource={data.serviceProductStockItems.map(b => ({ key: b.id, ...b }))}
                        columns={columns}
                        rowClassName="editable-row"
                        pagination={false}
                    />
                </Form>
            </Col>
        </Row>
    );
    const filters = (
        <Row style={{ marginTop: 4 }}>
            <Col span={24}>
                <MultiSelect
                    selected={filter}
                    placeholder='Select stock status'
                    options={["ACTIVE", "INACTIVE"]}
                    onChange={setFilter} />
            </Col>
        </Row>
    )

    return (
        <React.Fragment>
            {control}
            {filters}
            {context}
        </React.Fragment>
    )
}

export default withClinic(ServiceStockItemPage);
